"use strict";
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processList = exports.TaskManager = exports.Semaphore = void 0;
class Semaphore {
    constructor(initialCount) {
        this.waitingQueue = [];
        this.count = initialCount;
    }
    async acquire() {
        if (this.count > 0) {
            await new Promise((resolve) => {
                this.waitingQueue.push(resolve);
            });
        }
        this.count++;
    }
    release() {
        this.count--;
        const next = this.waitingQueue.shift();
        if (next) {
            next();
        }
    }
}
exports.Semaphore = Semaphore;
class TaskManager {
    constructor() {
        this.jobs = [];
        this.activeJob = null;
        this.semaphore = new Semaphore(0);
    }
    add(job) {
        const onList = this.getActiveJobById(job.id);
        if (onList)
            throw "job already in list";
        this.jobs.push(job);
        this.processQueue();
    }
    getActiveJobById(id) {
        return this.jobs.find(j => j.id == id);
    }
    async processQueue() {
        if (this.jobs.length <= 0)
            return;
        await this.semaphore.acquire();
        this.activeJob = this.jobs.shift();
        if (this.activeJob) {
            try {
                console.log(`running ${this.activeJob.id}`);
                await this.activeJob.task(this.activeJob.params);
            }
            catch (e) {
                console.error(e);
            }
            await this.semaphore.release();
            this.processQueue();
        }
    }
}
exports.TaskManager = TaskManager;
function processList(list, processor, maxItemsPerMinute = 60) {
    return __asyncGenerator(this, arguments, function* processList_1() {
        const delayMs = Math.ceil(60000 / maxItemsPerMinute);
        for (const item of list) {
            try {
                yield __await(processor(item));
                yield yield __await(true);
            }
            catch (e) {
                if (e == 'cancel') {
                    yield yield __await('cancel');
                    return yield __await(void 0);
                }
                console.error(e);
                yield yield __await(false);
            }
            yield __await(new Promise((resolve) => setTimeout(resolve, delayMs)));
        }
        yield yield __await('complete');
    });
}
exports.processList = processList;
//# sourceMappingURL=TaskManager.js.map